import { JSX } from 'react';
import { siteContent } from '../../data/content';

export default function Footer(): JSX.Element {
  const { footer } = siteContent;

  return (
    <footer className="bg-gray-900 dark:bg-gray-950 text-gray-300">
      <div className="container-max section-padding">
        {/* MVP Footer - Simple and Clean */}
        <div className="py-12">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
            {/* Company Info and Contact */}
            <div className="text-center md:text-left">
              <div className="mb-4">
                <span className="text-2xl font-bold text-white">
                  {footer.company.name}
                </span>
              </div>
              <div className="space-y-2 text-sm">
                <p className="text-gray-400">Contact Us:</p>
                <p>
                  <a 
                    href={`mailto:${footer.company.email}`}
                    className="hover:text-primary-400 transition-colors duration-200"
                  >
                    {footer.company.email}
                  </a>
                </p>
              </div>
            </div>

            {/* Copyright and Legal Links */}
            <div className="text-center md:text-right">
              <p className="text-sm text-gray-400 mb-2">
                © {new Date().getFullYear()} {footer.company.name}. All rights reserved.
              </p>
              <div className="flex items-center justify-center md:justify-end space-x-4 text-sm">
                <a 
                  href="/terms" 
                  className="text-gray-400 hover:text-primary-400 transition-colors duration-200"
                >
                  Terms of Service
                </a>
                <span className="text-gray-600">•</span>
                <a 
                  href="/privacy" 
                  className="text-gray-400 hover:text-primary-400 transition-colors duration-200"
                >
                  Privacy Policy
                </a>
              </div>
               {/*
              <div className="flex items-center justify-center md:justify-end space-x-2">
                <span className="text-sm text-gray-400">🇨🇭 Made in Switzerland</span>
              </div>
              */}
            </div>
          </div>
        </div>

        {/* All other footer sections commented out for MVP launch */}
        {/*
        <div className="py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
            <div className="lg:col-span-2">
              <div className="mb-6">
                <span className="text-2xl font-bold text-white">
                  {footer.company.name}
                </span>
              </div>
              <div className="space-y-2 text-sm">
                <p>{footer.company.address}</p>
                <p>
                  <a 
                    href={`mailto:${footer.company.email}`}
                    className="hover:text-primary-400 transition-colors duration-200"
                  >
                    {footer.company.email}
                  </a>
                </p>
                <p>
                  <a 
                    href={`tel:${footer.company.phone}`}
                    className="hover:text-primary-400 transition-colors duration-200"
                  >
                    {footer.company.phone}
                  </a>
                </p>
              </div>
              
              <div className="mt-6 flex space-x-4">
                {footer.social.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    className="text-gray-400 hover:text-primary-400 transition-colors duration-200"
                    aria-label={item.name}
                  >
                    <span className="sr-only">{item.name}</span>
                    <div className="w-6 h-6 bg-gray-600 rounded"></div>
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-white mb-4">Solutions</h3>
              <ul className="space-y-2">
                {footer.links.solutions.map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.href}
                      className="text-sm hover:text-primary-400 transition-colors duration-200"
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-white mb-4">Industries</h3>
              <ul className="space-y-2">
                {footer.links.industries.map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.href}
                      className="text-sm hover:text-primary-400 transition-colors duration-200"
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-white mb-4">Resources</h3>
              <ul className="space-y-2 mb-6">
                {footer.links.resources.map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.href}
                      className="text-sm hover:text-primary-400 transition-colors duration-200"
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
              
              <h3 className="text-sm font-semibold text-white mb-4">Legal</h3>
              <ul className="space-y-2">
                {footer.links.legal.map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.href}
                      className="text-sm hover:text-primary-400 transition-colors duration-200"
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-400">
              © {new Date().getFullYear()} {footer.company.name}. All rights reserved.
            </p>
            <div className="mt-4 md:mt-0 flex items-center space-x-4">
              <div className="flex items-center space-x-2">
                <div className="w-4 h-4 bg-success-500 rounded-full"></div>
                <span className="text-sm text-gray-400">All systems operational</span>
              </div>
              <div className="flex items-center space-x-2">
                <span className="text-sm text-gray-400">🇨🇭 Made in Switzerland</span>
              </div>
            </div>
          </div>
        </div>
        */}
      </div>
    </footer>
  );
}
